import { ContainerComponent, wrap } from 'AppReact';
import { SecondaryTextSmBold } from 'atoms';
import { Td, Tr, FlexCenterBetweenWrapper, Px4 } from 'wrappers';
import { formatPrice } from 'utils';
import internalState from './internalState';

export const definition = {
  name: 'FooterRowContainer',
  controller: {},
  initialProps: ({ area }) => ({ area }),
  props: internalState,
  elements: [
    {
      wrapper: Tr,
      name: 'Row',
      displayState: ({ }) => ({
        height: '48px',
        background: '#E7EBEB',
      }),
      elements: [
        {
          wrapper: Td,
          name: 'Header',
          colSpan: 8,
          displayState: ({ }) => ({
            borderRadius: '0px 0px 8px 8px',
            borderBottom: '1px solid #E3E3E3',
            borderLeft: '1px solid #E3E3E3',
            borderRight: '1px solid #E3E3E3',
          }),
          elements: [
            {
              wrapper: wrap(FlexCenterBetweenWrapper, Px4),
              name: 'TotalWrapper',
              elements: [
                {
                  component: SecondaryTextSmBold,
                  name: 'TotalText',
                  displayValue: ({ }) => `Total`,
                },
                {
                  component: SecondaryTextSmBold,
                  name: 'Cost',
                  displayValue: ({ area }) => {
                    const total = area?.items?.reduce((sum, item) => sum + (item.costs ?? 0), 0);
                    return `$${formatPrice((total ?? 0) / 100, true)}`;
                  },
                },
              ]
            }
          ]
        },
      ]
    }
  ]
}

export default ContainerComponent(definition);
